"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateTime = exports.dateTime = exports.createUTCDateTime = exports.createDateTime = void 0;
var dayjs_1 = __importDefault(require("../dayjs"));
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var createDateTime = function (input, format, timeZone) {
    var date = format ? (0, dayjs_1.default)(input, format, constants_1.STRICT) : (0, dayjs_1.default)(input);
    return (timeZone ? date.tz(timeZone) : date);
};
exports.createDateTime = createDateTime;
var createUTCDateTime = function (input, format) {
    return (format ? dayjs_1.default.utc(input, format, constants_1.STRICT) : dayjs_1.default.utc(input));
};
exports.createUTCDateTime = createUTCDateTime;
/**
 * Creates a DateTime instance.
 * @param opt
 * @param {DateTimeInput=} opt.input - input to parse.
 * @param {string=} opt.format - strict {@link https://dayjs.gitee.io/docs/en/display/format format} for parsing user's input.
 * @param {string=} opt.timeZone - specified {@link https://dayjs.gitee.io/docs/en/timezone/timezone time zone}.
 * @param {string=} opt.lang - specified locale.
 */
var dateTime = function (opt) {
    var _a = opt || {}, input = _a.input, format = _a.format, timeZone = _a.timeZone, lang = _a.lang;
    var prevLang = dayjs_1.default.locale();
    var shouldSetLocale = lang && prevLang !== lang;
    if (shouldSetLocale) {
        dayjs_1.default.locale(lang);
    }
    var date = (0, utils_1.compareStrings)(timeZone, constants_1.UtcTimeZone, { ignoreCase: true })
        ? (0, exports.createUTCDateTime)(input, format)
        : (0, exports.createDateTime)(input, format, timeZone);
    if (shouldSetLocale) {
        dayjs_1.default.locale(prevLang);
    }
    return date;
};
exports.dateTime = dateTime;
/**
 * Checks if value is DateTime.
 * @param {unknown} value - value to check.
 */
var isDateTime = function (value) {
    return dayjs_1.default.isDayjs(value);
};
exports.isDateTime = isDateTime;
